import { makeVar } from '@apollo/client'

/* 
A reactive variable to manage BE cache invalidation for case verification queries
It is important to note that this is not linked to Apollo cache, but rather a Set of verification calls represented as keys to inform the backend to bypass its cache for specific requests
This is particularly useful in scenarios where immediate data consistency is required (query has a cache duration of 10 minutes on the backend)
When the set does not contain the current requests key, the next case verification query will include the parameter ignore_cache=true, prompting the backend to fetch fresh data
After the query is made, the key is added to the Set to avoid affecting subsequent queries unintentionally
*/

// In-memory reactive variable
// Defaults to empty Set invalidating all BE cache entries
export const verificationCacheInvalidation = makeVar<Set<string>>(new Set())

export const setVerificationCacheInvalidation = () => {
  verificationCacheInvalidation().clear()
}

export const reverifyCacheInvalidationKey = (key: string) => {
  verificationCacheInvalidation().add(key)
}

export const isVerificationCacheValid = (key: string): boolean => {
  return verificationCacheInvalidation().has(key)
}

// Uses case_id and verification request params to build a key, this somewhat maps the BE solution for differentiating
// between cache instances
export const generateVerificationCacheKey = (
  caseId: string,
  caseRequirements: boolean,
  documentRequirements: boolean,
  showPass: boolean,
): string => {
  const key = `${caseId}_${caseRequirements}_${documentRequirements}_${showPass}`
  return key
}
